import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NonConformanceReportConcernOrigin } from "@enums/nonConformanceReportConcernOrigin.enum";
import { NonConformanceReportPriority } from "@enums/nonConformanceReportPriority.enum";
import { NonConformanceReportStatus } from "@enums/nonConformanceReportStatus.enum";
import { environment } from "@environments/environment";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { CreateQuarantinedPartFromNonConformanceReportDto } from "@interfaces/dto/createQuarantinedPartFromNonConformanceReportDto.interface";
import { Client } from "@interfaces/models/client.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { NonConformanceReport } from "@interfaces/models/nonConformanceReport.interface";
import { Part } from "@interfaces/models/part.interface";
import { QuarantinedPart } from "@interfaces/models/quarantinedPart.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { NonConformanceReportTimesheetLineData } from "@interfaces/nonConformanceReportTimesheetLineData.interface";
import { NonConformanceReportUserProfileLineData } from "@interfaces/nonConformanceReportUserProfileLineData.interface";
import { PartProcessRouter } from "@interfaces/partProcessRouter.interface";
import { Project } from "@interfaces/project.interface";
import { SupportingDocumentFileLineData } from "@interfaces/supportingDocumentFileLineData.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { WorkOrder } from "@interfaces/workOrder.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { ClientService } from "@services/client.service";
import { FileService } from "@services/file.service";
import { MachineService } from "@services/machine.service";
import { NonConformanceReportService } from "@services/nonConformanceReport.service";
import { PartService } from "@services/part.service";
import { ProjectService } from "@services/project.service";
import { QuarantinedPartService } from "@services/quarantinedPart.service";
import { SupplierService } from "@services/supplier.service";
import { UserProfileService } from "@services/userProfile.service";
import { WorkOrderService } from "@services/workOrder.service";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "nonConformanceReports-id",
	styleUrls: ["nonConformanceReports-id.css"],
	templateUrl: "nonConformanceReports-id.html"
})
export class NonConformanceReportsIdAdminComponent {
	areasOfIssue: string[] = [
		"CAD Issue",
		"Health and Safety",
		"Issue Found at Customer",
		"Maintenance Issue",
		"Person / Training Issue",
		"Process wrong",
		"Process - Assembly",
		"Process - 5 Axis Issue",
		"Process - Flat Laser issue",
		"Process - Goods-In",
		"Process - Press Issue",
		"Process - Press Brake issue",
		"Process - Weld Issue",
		"Process - Spot Weld Issue",
		"Process - Kingsland Issue",
		"Process - Fab/Deburr Issue",
		"Process - Firewall Issue",
		"Process - Logistics issue",
		"Process - Quality Issue",
		"Process - Toolroom",
		"Supplier - Material Issue",
		"Supplier - Outsource Issue",
	];
	changes: any = [];
	clients: Client[] = [];
	concernOrigins: any;
	createEnabled = true;
	currentUserProfile: UserProfile = new UserProfile;
	dropDownProcessRouters: any[] = [];
	editEnabled = true;
	editRowKey: any = null;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	imageButtonOptions = {
		onClick: () => this.addNewImagePopup(),
		text: "Add Image",
		type: "default",
		useSubmitBehavior: false
	}
	images: SupportingDocumentFileLineData[] = [];
	isQualityManagement = false;
	isSuperAdmin = false;
	item: NonConformanceReport = new NonConformanceReport();
	itemId = 0;
	itemType = "Non Conformance Report";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	machines: Machine[] = [];
	otherCostTypes: string[] = ["3rdPartyContainment", "Logistics", "Rework", "MachineTime", "Scrap"];
	otherCosts: any[] = [];
	parts: Part[] = [];
	people: UserProfile[] = [];
	peopleResponsibleForClosure: NonConformanceReportUserProfileLineData[] = [];
	peopleResponsibleForClosureButtonOptions = {
		onClick: () => this.addNewUserProfileLinkPopup(),
		text: "Add Employee",
		type: "default",
		useSubmitBehavior: false
	}
	popupAddButtonOptions: any;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupCreateQuarantinedPartFromNonConformanceReportDto = new CreateQuarantinedPartFromNonConformanceReportDto();
	popupImage: SupportingDocumentFileLineData = new SupportingDocumentFileLineData();
	popupOtherCostInvoiceRow: any = null;
	popupSupportingDocument: SupportingDocumentFileLineData = new SupportingDocumentFileLineData();
	popupTitle = "";
	popupUserProfile: NonConformanceReportUserProfileLineData = new NonConformanceReportUserProfileLineData();
	popupVisible = false;
	priorities: any;
	processRouters: PartProcessRouter[] = [];
	projects: Project[] = [];
	qualityCostPerHour = 45;
	quarantinedParts: QuarantinedPart[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	riskRatings = [{ id: 1, text: "1 - Internal Only"}, { id: 2, text: "2 - Impacts Client, 8D Required"}];
	screenMode = "";
	statuses: any;
	suppliers: Supplier[] = [];
	supportingDocumentButtonOptions = {
		onClick: () => this.addNewSupportingDocumentPopup(),
		text: "Add Document",
		type: "default",
		useSubmitBehavior: false
	}
	supportingDocuments: SupportingDocumentFileLineData[] = [];
	timesheet: NonConformanceReportTimesheetLineData[] = [];
	title: string = "View " + this.itemType;
	workOrders: WorkOrder[] = [];
	workOrdersDropDown: WorkOrder[] = [];

	constructor(private router: Router, private toastService: ToastService, private appSettingsService: AppSettingsService, private route: ActivatedRoute, private clientService: ClientService, private fileService: FileService, private machineService: MachineService, private itemService: NonConformanceReportService, private partService: PartService, private projectService: ProjectService, private quarantinedPartService: QuarantinedPartService, private supplierService: SupplierService, private workOrderService: WorkOrderService, private userProfileService: UserProfileService) {
		this.getClients();
		this.getCurrentUserProfile();
		this.getParts();
		this.getPeople();
		this.getProjects();
		this.getQualityCostPerHour();
		this.getSuppliers();
		this.getMachines();
		this.getWorkOrders();

		this.concernOrigins = GetPropertiesFromEnum(NonConformanceReportConcernOrigin);
		this.priorities = GetPropertiesFromEnum(NonConformanceReportPriority);
		this.statuses = GetPropertiesFromEnum(NonConformanceReportStatus);

		this.isQualityManagement = CheckGroupPermissions(appSettingsService, "Quality Management");
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");		

		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.getItem(params.id.split("_")[0], "edit");
					this.edit();
				} else {
					this.getItem(params.id, "view");
				}
			} else {
				this.create();
			}
		});

		this.calculateTimesheetCostCellValue = this.calculateTimesheetCostCellValue.bind(this);
		this.deleteImageLink = this.deleteImageLink.bind(this);
		this.deleteSupportingDocumentLink = this.deleteSupportingDocumentLink.bind(this);
		this.deleteUserProfileLink = this.deleteUserProfileLink.bind(this);
		this.downloadFileLink = this.downloadFileLink.bind(this);
		this.onInitNewTimesheetRow = this.onInitNewTimesheetRow.bind(this);
		this.onInitNewOtherCostRow = this.onInitNewOtherCostRow.bind(this);
		this.setOtherCostInvoiceRow = this.setOtherCostInvoiceRow.bind(this);
		this.uploadImage = this.uploadImage.bind(this);
		this.uploadOtherCostInvoice = this.uploadOtherCostInvoice.bind(this);
		this.downloadOtherCostInvoice = this.downloadOtherCostInvoice.bind(this);
		this.uploadSupportingDocument = this.uploadSupportingDocument.bind(this);
		this.viewImage = this.viewImage.bind(this);
	}

	get isClosed(): boolean {
		return this.item?.status === NonConformanceReportStatus.Closed;
	}

	addNewImage() {		
		this.images.push(this.popupImage);
		this.popupImage = new SupportingDocumentFileLineData();
		this.closePopup();
	}

	addNewImagePopup() {
		this.popupImage = new SupportingDocumentFileLineData();
		this.popupTitle = "Add New Image";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewImage(), text: "Add Image" };
	}

	addNewSupportingDocument() {
		if (this.popupSupportingDocument.description === "") {
			alert("Please enter a description");
			return;
		}
		this.supportingDocuments.push(this.popupSupportingDocument);
		this.popupSupportingDocument = new SupportingDocumentFileLineData();
		this.closePopup();
	}

	addNewSupportingDocumentPopup() {
		this.popupSupportingDocument = new SupportingDocumentFileLineData();
		this.popupTitle = "Add New Supporting Document";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupportingDocument(), text: "Add Document" };
	}

	addNewUserProfileLink() {		
		this.peopleResponsibleForClosure.push(this.popupUserProfile);
		this.popupUserProfile = new NonConformanceReportUserProfileLineData();
		this.closePopup();
	}

	addNewUserProfileLinkPopup() {
		this.popupUserProfile = new NonConformanceReportUserProfileLineData();
		this.popupTitle = "Add New Responsible Employee";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewUserProfileLink(), text: "Add Employee" };
	}

	boolYesNo(cellInfo: any) {
		if (cellInfo.value === true) {
			return "YES";
		}
		else {
			return "NO";
		}
	}

	buildButtons(mode: string) {
		this.screenMode = mode;
		this.headerPrimaryButtons = [];
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];

		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "Cancel" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.title = "View " + this.itemType + " #" + this.item.id;
			if (this.item.status === NonConformanceReportStatus.Closed) {
				if (this.isQualityManagement || this.isSuperAdmin) {
					this.headerTertiaryButtons.push({ method: "reopenNonConformanceReport", text: "Reopen NCR" });
				}
				this.headerSecondaryButtons = [{ method: "viewTimesheetPopup", text: "Timesheet" }];
			} else {
				this.headerPrimaryButtons.push({ method: "edit", text: "Edit" });
				this.headerSecondaryButtons = [{ method: "viewTimesheetPopup", text: "Timesheet" }];
				this.headerTertiaryButtons = [{ method: "notifyStaff", text: "Notify Staff" }];

				if ((this.isQualityManagement || this.isSuperAdmin)
					&& this.item.concern !== null && this.item.concern !== undefined && this.item.concern.length > 1
					&& this.item.containment !== null && this.item.containment !== undefined && this.item.containment.length > 1
					&& this.item.correctiveAction !== null && this.item.correctiveAction !== undefined && this.item.correctiveAction.length > 1
					&& this.item.rootCause !== null && this.item.rootCause !== undefined && this.item.rootCause.length > 1
					&& this.item.problemSolvingToolUsed == true
					&& ((this.item.riskRating === 1 && (this.item.problemSolvingTool1 === true || this.item.problemSolvingTool2 === true || this.item.problemSolvingTool3 || this.item.problemSolvingTool4 === true || this.item.problemSolvingTool5 === true || this.item.problemSolvingTool6 === true))
					|| (this.item.riskRating === 2 && this.item.problemSolvingTool1 === true && this.item.problemSolvingTool2 === true && this.item.problemSolvingTool3 && this.item.problemSolvingTool4 === true && this.item.problemSolvingTool5 === true && this.item.problemSolvingTool6 === true)))
				{
					this.headerTertiaryButtons.push({ icon: "fal fa-file-times", method: "closeNonConformanceReport", style:"background-color: #f00; color: #fff;", text: "Close NCR" });
				}

				if ((this.isQualityManagement || this.isSuperAdmin)
					&& this.item.partId != null && this.item.partId != undefined && this.item.partId > 0)
				{
					this.headerTertiaryButtons.push({ icon: "fal fa-dumpster-fire", method: "quarantinePartsPopup", style:"background-color: #f00; color: #fff;", text: "Quarantine Parts" });
				}
			}

			this.headerPrimaryButtons.push({ method: "close", text: "Close" });
			this.headerSecondaryButtons.push({ icon: "fal fa-download", method: "generateAndDownloadSummaryPDF", text: "Summary PDF" });
			if (this.item.carePoint === true) {
				this.headerSecondaryButtons.push({ icon: "fal fa-download", method: "generateAndDownloadCarepointPDF", text: "Carepoint PDF" });
			}
		}
	}

	calculateTimesheetCostCellValue(data: any) {
		const userProfile = this.people.find(p => p.id === data.userId);
		const hourlyRate = userProfile !== undefined && userProfile.internalCost !== undefined && userProfile.internalCost !== null && userProfile.internalCost > 0
			? userProfile.internalCost
			: this.qualityCostPerHour;
		return (data.time || 0) * hourlyRate;
	}

	calculateTimesheetTotalCost() {
		let labourCost = 0;
		this.timesheet.forEach(lineItem => {
			labourCost += this.calculateTimesheetCostCellValue(lineItem);
		});

		let otherCostsTotal = 0;
		this.otherCosts.forEach(costLine => {
			otherCostsTotal += Number(costLine.totalCost || 0);
		});

		return labourCost + otherCostsTotal;
	}

	// Cancel discards unsaved edits by reloading the saved NCR. It used to only switch to read-only, so
	// documents, images or text added in edit mode but never saved stayed on screen as if saved - and
	// "Close NCR" (view mode only) then closed the saved record without them.
	cancelEditing() {
		this.readOnly = true;
		this.getItem(this.item.lookupId, "view");
	}

	close() {
		if (this.screenMode === "view" || confirm("Are you sure you wish to leave the page? Unsaved changes will be discarded.")) {
			this.router.navigate([`/${this.returnUrl}/`]);
		}
	}

	closeNonConformanceReport() {
		if (this.item.status === NonConformanceReportStatus.Closed || this.screenMode !== "view") {
			return;
		}

		if (confirm("Are you sure you want to close this NCR?") == false) {
			return;
		}

		this.itemService.closeNonConformanceReport(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Closed " + this.itemType);
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	closePopup() {
		this.popupVisible = false;
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.prepareItemForSaving();

		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added New " + this.itemType);
					this.item = new NonConformanceReport();
					this.screenMode = "view";
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deleteImageLink(e: any) {
		const index = this.images.findIndex(d => d.lookupId === e.row.data.lookupId);
		this.images.splice(index, 1);

		return false;
	}

	deleteSupportingDocumentLink(e: any) {
		const index = this.supportingDocuments.findIndex(d => d.lookupId === e.row.data.lookupId);
		this.supportingDocuments.splice(index, 1);

		return false;
	}

	deleteUserProfileLink(e: any) {
		const index = this.peopleResponsibleForClosure.findIndex(d => d.userProfileId === e.row.data.userProfileId);
		this.peopleResponsibleForClosure.splice(index, 1);

		return false;
	}

	displayWorkOrderInDropdown(e: any) { 
		return e === null || e === undefined ? "" : e.id + " (" + e.quantity + " parts)";
	}

	downloadFileLink(e: any) {
		const lookupId = Guid.parse(e.row.data.lookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	downloadOtherCostInvoice(e: any) {
		if (e.row.data.invoiceLookupId === undefined || e.row.data.invoiceLookupId === null) {
			return false;
		}
		const lookupId = Guid.parse(e.row.data.invoiceLookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", e.row.data.invoiceFileName || "invoice");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "riskRating":
				if (args.value === 2) {
					this.item.priority = NonConformanceReportPriority.High;
				}
				break;
			case "partId":
				this.getProcessRouters();
				break;
		}
	}

	generateAndDownloadCarepointPDF() {
		this.itemService.generateAndDownloadCarepointPdf(this.item.id).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "NCR_" + this.item.id + "_Carepoint.pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	generateAndDownloadSummaryPDF() {
		this.itemService.generateAndDownloadSummaryPdf(this.item.id).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "NCR_" + this.item.id + "_Summary.pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) => {
					this.clients = res.response.items;
					this.clients.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}
	
	getCurrentUserProfile() {
		this.userProfileService.getCurrentUserProfile()
			.subscribe(
				(res: any) =>  {
					this.currentUserProfile = res.response;
				},
				(err) => console.log(err)
			);
	}

	getItem(lookupId: Guid, mode: string) {
		this.itemService.getSingleByLookupId(lookupId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.images = JSON.parse(this.item.images);
					this.supportingDocuments = JSON.parse(this.item.supportingDocuments);
					this.peopleResponsibleForClosure = JSON.parse(this.item.peopleResponsibleForClosure);
					const parsedTimesheet = JSON.parse(this.item.timesheet);
					if (Array.isArray(parsedTimesheet)) {
						this.timesheet = parsedTimesheet;
						this.otherCosts = [];
					} else {
						this.timesheet = parsedTimesheet?.timeEntries || [];
						this.otherCosts = parsedTimesheet?.otherCosts || [];
					}
					
					this.buildButtons(mode);

					if (this.parts.length > 0) {
						this.getProcessRouters();
					}

					this.getQuarantinedParts();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
	
	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) =>  {
					this.machines = res.response.items;
					this.machines.sort((a,b) => a.cellNumber.localeCompare(b.cellNumber));
				},
				(err) => console.log(err)
			);
	}
	
	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) =>  {
					this.parts = res.response.items;
					this.parts.sort((a,b) => a.partNumber.localeCompare(b.partNumber));

					if (this.item.id > 0) {
						this.getProcessRouters();
					}
				},
				(err) => console.log(err)
			);
	}
	
	getPeople() {
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	getProcessRouters() {
		this.dropDownProcessRouters = [];

		if (this.item.partId === undefined || this.item.partId === null || this.parts.length == 0) {
			this.processRouters = [];
			return;
		}

		const part = this.parts.filter(p => p.id === this.item.partId)[0];

		this.processRouters = JSON.parse(part.router);

		this.processRouters.forEach(et => {
			this.dropDownProcessRouters.push({ id: et.stage, name: "OP" + et.stage.toString() + "0" });
		});
	}
	
	getProjects() {
		this.projectService.getAll()
			.subscribe(
				(res: any) =>  {
					this.projects = res.response.items;
					this.projects.sort((a,b) => a.displayName.localeCompare(b.displayName));
				},
				(err) => console.log(err)
			);
	}

	getQualityCostPerHour() {
		this.itemService.getNCRQualityCostPerHour()
			.subscribe(
				(res: any) => {
					this.qualityCostPerHour = res.response;
				},
				(err) => console.log(err)
			);
	}

	getQuarantinedParts() {
		this.quarantinedPartService.getByNonConformanceReportId(this.item.id)
			.subscribe(
				(res: any) => {
					this.quarantinedParts = res.response;
				},
				(err) => console.log(err)
			);
	}

	getSuppliers() {
		this.supplierService.getAll()
			.subscribe(
				(res: any) => {
					this.suppliers = res.response.items;
					this.suppliers.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}
	
	getWorkOrders() {
		this.workOrderService.getAll()
			.subscribe(
				(res: any) =>  {
					this.workOrders = res.response.items;
				},
				(err) => console.log(err)
			);
	}
	
	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	notifyStaff() {
		if (this.item.status === NonConformanceReportStatus.Closed || this.screenMode !== "view") {
			return;
		}

		if (confirm("This will generate a PDF summary of the NCR and send it to the staff mailbox. Proceed?") == false) {
			return;
		}

		this.itemService.notifyStaff(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Notified Staff");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
 
	onInitNewOtherCostRow(row: any) {
		row.data.totalCost = 0;
	}

	onInitNewTimesheetRow(row: any) {
		row.data.userId = this.currentUserProfile.id;
		row.data.date = new Date;
	}

	prepareItemForSaving() {
		if (this.item.partId === 0) { this.item.partId = undefined; }
		if (this.item.machineId === 0) { this.item.machineId = undefined; }

		this.item.images = JSON.stringify(this.images);
		this.item.peopleResponsibleForClosure = JSON.stringify(this.peopleResponsibleForClosure);
		this.item.supportingDocuments = JSON.stringify(this.supportingDocuments);
		this.item.timesheet = JSON.stringify({ otherCosts: this.otherCosts, timeEntries: this.timesheet });
		
		let totalTime = 0;
		this.timesheet.forEach(lineItem => {
			totalTime += Number(lineItem.time || 0);
		});
		this.item.totalTime = totalTime;
		this.item.totalCost = this.calculateTimesheetTotalCost();
	}

	quarantineParts() {
		if ((this.popupCreateQuarantinedPartFromNonConformanceReportDto.numberOfPartsAffected <= 0) || this.screenMode !== "view") {
			return;
		}

		if (confirm("Are you sure you want to quarantine " + this.popupCreateQuarantinedPartFromNonConformanceReportDto.numberOfPartsAffected + " of this part from work order " + this.popupCreateQuarantinedPartFromNonConformanceReportDto.workOrderId + "? This cannot be undone until the quarantine is resolved.") == false) {
			return;
		}

		this.quarantinedPartService.createFromNonConformanceReport(this.popupCreateQuarantinedPartFromNonConformanceReportDto)
			.subscribe(
				() => {
					this.toastService.success("Successfully Quarantined parts");
					this.getItem(this.item.lookupId, this.screenMode);
					this.getQuarantinedParts();
					this.item.numberOfPartsAffected += this.popupCreateQuarantinedPartFromNonConformanceReportDto.numberOfPartsAffected;
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error(err);
				}
			);
	}

	quarantinePartsPopup() {
		this.popupCreateQuarantinedPartFromNonConformanceReportDto = new CreateQuarantinedPartFromNonConformanceReportDto();
		this.popupCreateQuarantinedPartFromNonConformanceReportDto.nonConformanceReportId = this.item.id;
		this.popupTitle = "Add New Quarantine";
		this.popupVisible = true;
		this.workOrdersDropDown = this.workOrders.filter(wo => wo.partId == this.item.partId);
		this.popupAddButtonOptions = { onClick: () => this.quarantineParts(), text: "Add Quarantine" };
	}

	reopenNonConformanceReport() {
		if (this.item.status !== NonConformanceReportStatus.Closed || this.screenMode !== "view" || (this.isQualityManagement === false && this.isSuperAdmin === false)) {
			return;
		}

		if (confirm("Are you sure you want to reopen this NCR? This can't be undone.") == false) {
			return;
		}

		this.itemService.reopenReport(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Reopened " + this.itemType);
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	setOtherCostInvoiceRow(e: any) {
		this.popupOtherCostInvoiceRow = e.row.data;
	}

	updateItem() {
		if (this.item.status === NonConformanceReportStatus.Closed) {
			return;
		}

		this.closePopup();
		this.prepareItemForSaving();

		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.readOnly = true;
					this.getItem(this.item.lookupId, "view");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	uploadImage(file: File) {
		const containerName = "images";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupImage.lookupId = res.response[0].lookupId;
					this.popupImage.fileName = res.response[0].name;
					this.popupImage.fileUrl = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Image Upload Failed - Please ensure you are uploading a valid image file");
				}
			);
	}

	uploadOtherCostInvoice(file: File) {
		if (this.popupOtherCostInvoiceRow === null) {
			this.toastService.error("Please choose an Other Cost row first");
			return;
		}
		const containerName = "nonconformancereportfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupOtherCostInvoiceRow.invoiceLookupId = res.response[0].lookupId;
					this.popupOtherCostInvoiceRow.invoiceFileName = res.response[0].name;
					this.toastService.success("Invoice uploaded");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Invoice Upload Failed");
				}
			);
	}

	uploadSupportingDocument(file: File) {
		const containerName = "nonconformancereportfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupSupportingDocument.lookupId = res.response[0].lookupId;
					this.popupSupportingDocument.fileName = res.response[0].name;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Supporting Document Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}

	viewImage(e: any) {
		const imageUrl = e.row.data.fileUrl;
		const viewLink = document.createElement("a");
		viewLink.href = imageUrl;
		document.body.appendChild(viewLink);
		viewLink.click();
		return false;
	}

	viewTimesheetPopup() {
		this.popupTitle = "Timesheet";
		this.popupVisible = true;
		// A closed NCR's timesheet is view-only (the API rejects updates to closed NCRs).
		this.popupAddButtonOptions = this.isClosed
			? { visible: false }
			: { onClick: () => this.updateItem(), text: "Save Changes" };
	}
}